<!-- Operation Search -->
<scf-search-panel
  [currentState]="currentState"
  (changeOnSearchEvent)="changeView($event)"
  (changeSearchView)="onChangeSearchView($event)"
></scf-search-panel>
<!-- Panel Card -->
<div *ngFor="let state of statusRequests">
  <!-- Mostrar si es el panel principal o mostrar si no es panel principal y el titulo se corresponde con el que hayas seleccionado -->
  <scf-request-panel
    *ngIf="isMainPanel || (!isMainPanel && titleSingleView === state.id)"
    [isMainPanel]="isMainPanel"
    [state]="state"
    [isPendingRequests]="state.id === '00' ? true : false"
    [searchOperations]="searchParams"
    [isFilter]="isFilter"
    (allData)="loadAllData($event)"
    (changeContinueView)="updateView($event)"
    (viewRequest)="viewRequest($event)"
    (finishedLoading)="changeRequestsState($event)"
  >
  </scf-request-panel>
</div>

<!-- Footer Buttons -->
<div class="panel_footer__buttons" *ngIf="isMainPanel">
  <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
    <button id="createAllExcelPanel" mat-stroked-button color="accent" (click)="createAllExcel()">
      <mat-icon class="icon-ic_file_download"></mat-icon>
      <span>{{ 'request.button.excel' | translate | uppercase }}</span>
    </button>
    <button id="createAllPdfPanel" mat-stroked-button color="accent" (click)="createAllPdf()">
      <mat-icon class="icon-ic_print"></mat-icon>
      <span>{{ 'request.button.print' | translate | uppercase }}</span>
    </button>
  </div>
</div>
